import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import Login from "../pages/login";
import Login from "pages/userLogin/Login";
import PrivateRoute from "./privateRoutes";
import PublicRoute from "./publiceRoutes";
import Home from "../pages/home/Home";
// import MyApplications from "../pages/applications";
// import MyApplications from "pages/applications/MyApplications";
import ApplicationList from "pages/applications/ApplicationList";
import BreRejectedApplications from "pages/breRejected/BreRejectedApplication";
import NotFound_404 from "../pages/NotFound_404/notFound_404";
import ApplicationDetails from "pages/applicationDetails";
import Partners from "pages/partners/Partners";
import PartnerHistory from "pages/partners/PartnerHistory";
import DMS from "pages/dms/DMS";
import Document from "pages/document/Document";
import Singup from "Signup";
import ESign from "pages/eSign/ESign";
import EMudra from "pages/eMudra/EMudra";
import PaymentLog from "pages/paymentLog/PaymentLog";
import EmudraHistory from "pages/eMudra/EmudraHistroy";
import UTR from "pages/utr/Utr";
import UTRHistroy from "pages/utr/UTRHistroy";
import Role from "pages/roleManagement/Role";
import AddUser from "pages/userManagement/User";

const Routers = () => {
  const token = localStorage.getItem("token");
  const getRoutesConditionally = () => {
   return (
        <Switch>
          <PublicRoute
            exact
            path={["/", "/login"]}
            component={Login}
          />
           <PublicRoute
            exact
            path={"/singup"}
            restricted={true}
            component={Singup}
          />
          <PrivateRoute
            exact
            path={'/home'}
            token={token}
            // component={MyApplications}
            component={Home}
          />
           <PrivateRoute
            exact
            path={'/applications'}
            token={token}
            component={ApplicationList}
          />
           <PublicRoute
            exact
            path={'/bre-rejected-applications'}
            // token={token}
            component={BreRejectedApplications}
          />
          <PrivateRoute
            exact
            path={'/application-details/:id'}
            token={token}
            component={ApplicationDetails}
          />
          <PrivateRoute
            exact
            path={'/partner-history/:id'}
            token={token}
            component={PartnerHistory}
          />
          <PrivateRoute
            exact
            path={'/partners'}
            token={token}
            component={Partners}
          />
          <PrivateRoute
            exact
            path={'/dms'}
            token={token}
            component={DMS}
          />
          <PrivateRoute
            exact
            path={'/documents'}
            token={token}
            component={Document}
          />
          <PrivateRoute
            exact
            path={'/eSign'}
            token={token}
            component={ESign}
          />
           <PrivateRoute
            exact
            path={'/eMudra'}
            token={token}
            component={EMudra}
          />
          <PrivateRoute
            exact
            path={'/paymentLog'}
            token={token}
            component={PaymentLog}
          />
          <PrivateRoute
            exact
            path={'/finType-history/:id'}
            token={token}
            component={EmudraHistory}
          />
          <PrivateRoute
            exact
            path={'/utr'}
            token={token}
            component={UTR}
          />
           <PrivateRoute
            exact
            path={'/UTR-history'}
            token={token}
            component={UTRHistroy}
          />
          <PrivateRoute
            exact
            path={'/role'}
            token={token}
            component={Role}
          />
          <PrivateRoute
            exact
            path={'/user'}
            token={token}
            component={AddUser}
          />
          <Route path="*" component={NotFound_404} />
        </Switch>
      );
  };
  return <Router>
      {getRoutesConditionally()}
  </Router>
};

export default Routers;
